module.exports = __webpack_public_path__ + "media/images/loghi/lba_logo_mob-d651fa7abfda7e19ef5353cca4e4ca11.png";